<template>
  <div class="feed-control-group">

    <div class="device-info">
      <div class="info-item">
        <span class="label">设备名称：</span>
        <span class="value">{{ item.deviceName || '未设置' }}</span>
      </div>
      <div class="info-item">
        <span class="label">设备编码：</span>
        <span class="value">{{ item.deviceCode || '未设置' }}</span>
      </div>
      <div class="info-item">
        <span class="label">备注：</span>
        <span class="value">{{ item.remark || '无' }}</span>
      </div>
    </div>

    <div class="button-group-right">
      <div class="feed-btn-group">
        <div class="feed-edit-btn" @click="handleDeviceStart">开启浇灌</div>
        <div class="feed-edit-btn" @click="handleDeviceEnd">停止浇灌</div>
      </div>

      <div class="feed-device-status-wrap">
        <div
            class="feed-device-btn"
            :class="{ active: deviceStatus === 0 }"
            :disabled="deviceLoading"
            @mousedown="handleDeviceStart"
            @mouseup="handleDeviceEnd"
            @touchstart="handleDeviceStart"
            @touchend="handleDeviceEnd"
        >
          {{ deviceStatus === 0 ? '松开结束浇灌' : '按下开启浇灌' }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { openDeviceApi } from "../api/custom";
export default {
  name: 'Irrigation',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deviceLoading: false,
      deviceStatus: 1,
      token: ''
    }
  },
  created() {
    console.log("item:",this.item.id)
    console.log("item:",this.item)
    this.token = this.$route?.query?.token || '';
  },
  methods: {
    async handleDeviceStart() {
      const deviceId = this.item?.id;
      if (!deviceId || this.deviceLoading) return;
      this.deviceLoading = true;
      this.deviceStatus = 0;
      try {
        await this.setDeviceStatus(deviceId, 0);
      } finally {
        this.deviceLoading = false;
      }
    },
    async handleDeviceEnd() {
      const deviceId = this.item?.id;
      if (!deviceId) return;
      this.deviceStatus = 1;
      await this.setDeviceStatus(deviceId, 1);
    },
    async setDeviceStatus(deviceId, status) {
      try {
        const res = await openDeviceApi({ deviceId, status, token: this.token });
        if (res?.code !== 200) {
          this.$showToast?.(res.message || '操作失败', '错误', 'error');
        }
      } catch (err) {
        this.$showToast?.(err || '请求异常', '错误', 'error');
      }
    }
  }
}
</script>

<style scoped>
/* 🔥 强制！！！不允许任何压缩！！！ */
.feed-control-group * {
  font-size: 30px !important;
  line-height: 1.8 !important;
  font-weight: bold !important;
}

.feed-control-group {
  width: 100% !important;
  height: auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 20px !important;
  padding: 10px !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;
  transform: scale(1) !important;
}

.device-info {
  flex: 1 !important;
  background: rgba(0,0,0,0.4) !important;
  padding: 16px !important;
  border-radius: 12px !important;
  color: #fff !important;
}

.label {
  min-width: 180px !important;
}
.value {
  color: #42fcff !important;
}

.button-group-right {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.feed-btn-group {
  display: flex !important;
  gap: 10px !important;
}

.feed-edit-btn {
  flex: 1 !important;
  text-align: center !important;
  padding: 18px 0 !important;
  background: #2a7efb !important;
  color: #fff !important;
  border-radius: 12px !important;
  cursor: pointer !important;
}

.feed-device-btn {
  width: 100% !important;
  text-align: center !important;
  padding: 22px 0 !important;
  background: #2a7efb !important;
  color: #fff !important;
  border-radius: 12px !important;
  cursor: pointer !important;
}

.feed-device-btn.active {
  background: #ff4d4f !important;
}
.feed-device-btn[disabled] {
  opacity: 0.6 !important;
}
</style>